var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRejectedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F04639"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14098_7464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1875 20.0781C22.1875 19.6898 21.8727 19.375 21.4844 19.375H18.6719C18.2835 19.375 17.9688 19.6898 17.9688 20.0781C17.9688 20.4665 18.2835 20.7812 18.6719 20.7812H21.4844C21.8727 20.7812 22.1875 20.4665 22.1875 20.0781Z",
    fill: "#F04639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0781 15.1562C17.3642 15.1562 15.1562 17.3642 15.1562 20.0781C15.1562 22.792 17.3642 25 20.0781 25C22.792 25 25 22.792 25 20.0781C25 17.3642 22.792 15.1562 20.0781 15.1562ZM20.0781 23.5938C18.1396 23.5938 16.5625 22.0166 16.5625 20.0781C16.5625 18.1396 18.1396 16.5625 20.0781 16.5625C22.0166 16.5625 23.5938 18.1396 23.5938 20.0781C23.5938 22.0166 22.0166 23.5938 20.0781 23.5938Z",
    fill: "#F04639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67188 10.5156C9.67188 12.4541 11.249 14.0312 13.1875 14.0312C15.126 14.0312 16.7031 12.4541 16.7031 10.5156C16.7031 8.57711 15.126 7 13.1875 7C11.249 7 9.67188 8.57711 9.67188 10.5156ZM13.1875 8.40625C14.3506 8.40625 15.2969 9.35252 15.2969 10.5156C15.2969 11.6787 14.3506 12.625 13.1875 12.625C12.0244 12.625 11.0781 11.6787 11.0781 10.5156C11.0781 9.35252 12.0244 8.40625 13.1875 8.40625Z",
    fill: "#F04639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10938 22.1875H13.1882C13.5765 22.1875 13.8913 21.8727 13.8913 21.4844C13.8913 21.096 13.5765 20.7812 13.1882 20.7812H9.10938C8.72167 20.7812 8.40625 20.4658 8.40625 20.0781C8.40625 18.1396 9.98336 16.5625 11.9219 16.5625H14.4531C14.8415 16.5625 15.1562 16.2477 15.1562 15.8594C15.1562 15.471 14.8415 15.1562 14.4531 15.1562H11.9219C9.20795 15.1562 7 17.3642 7 20.0781C7 21.2412 7.94627 22.1875 9.10938 22.1875Z",
    fill: "#F04639"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14098_7464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedWhite);
export default __webpack_public_path__ + "static/media/rejectedWhite.2f85551588e0a5c6cffed8b5b5f84465.svg";
export { ForwardRef as ReactComponent };